<template>
  <div class="orders-cat">
    <div class="orders-cat-title">ЗАКАЗЫ</div>
    <filter-component v-if="isShowFilter()" :years="years" :fields="filter" :filter-event="searchOrders"/>
    <template v-if="orders.items.length">
      <div class="orders-items">
        <order-component
          v-for="order in orders.items"
          :key="order.id"
          :order="order"
        />
      </div>
      <pagination-component v-if="orders.pages.length" :items="orders.pages" @action="searchOrders" />
      <loader-component v-if="loader"/>
    </template>
    <div v-else>
      <p>В выбранном году заказы отсутствуют</p>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, ref, provide } from "vue";
import { loadScript } from 'vue-plugin-load-script';
import { setDeliveryPointRequest, getYearsRequest } from "@/api/orders";
import OrderComponent from "./order/OrderComponent";
import PaginationComponent from "../../../components/PaginationComponent";
import LoaderComponent from "../../../components/LoaderComponent";
import FilterComponent from "./filter/FilterComponent.vue";

export default {
  components: {
    OrderComponent,
    PaginationComponent,
    LoaderComponent,
    FilterComponent
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    isShowFilter: {
      type: Function,
      required: true
    }
  },
  setup() {

      const orders = inject('orders');
      const searchOrders = inject('searchOrders');
      const loader = inject('ordersLoader');
      const deliveryWidget = ref(null);
      const deliveryOrderId = ref(null);
      const years = ref([]);

      const handleSelectDeliveryPoint = (wat) => {
          if(!deliveryOrderId.value) {
              alert('Ошибка выбора пункта доставки');
              return;
          }
          loader.value = true;
          setDeliveryPointRequest(deliveryOrderId.value, {
              value: wat.cityName + ', ' + wat.PVZ.Address
          })
              .then(() => {
                  loader.value = false;
                  deliveryOrderId.value = null;
                  searchOrders();
              })
              .catch(err => console.log(err));
      };

      const initDeliveryWidget = () => {
          loadScript(process.env.VUE_APP_API_URL + "/widget-cdek/widjet.min.js").then(() => {
              deliveryWidget.value = new ISDEKWidjet({
                  path: process.env.VUE_APP_API_URL + '/widget-cdek/scripts/',
                  servicepath: process.env.VUE_APP_API_URL + '/widget-cdek/scripts/service.php',
                  templatepath: process.env.VUE_APP_API_URL + '/widget-cdek/scripts/template.php',
                  country: 'Россия',
                  defaultCity: 'Санкт-Петербург',
                  cityFrom: 'Санкт-Петербург',
                  popup: true,
                  choose: true,
                  hidedress: true,
                  hidecash: true,
                  hidedelt: true,
                  detailAddress: true,
                  onChoose: function (wat) {
                      handleSelectDeliveryPoint(wat);
                  }
              });
          }).catch(() => {});
      };

      onMounted(() => {
        initDeliveryWidget();
        getYearsRequest()
          .then(response => {
            if(response.data) {
              years.value = response.data.data;
            }
          })
          .catch(err => console.log(err));
      });

      provide('deliveryWidget', deliveryWidget);
      provide('deliveryOrderId', deliveryOrderId);

    return {
      orders,
      searchOrders,
      loader,
      years
    }
  }
}
</script>

<style scoped>

.orders-cat {
  padding: 15px;
  border: 1px solid #cccccc;
  border-radius: 15px;
  margin-bottom: 20px;
  position: relative;
}

.orders .orders-cat:last-child {
  margin-bottom: 0;
}

.orders-cat-title {
  position: absolute;
  top: -10px;
  left: 15px;
  background-color: #3294ca;
  padding: 3px 5px;
  text-transform: uppercase;
  font-size: 12px;
  color: #FFFFFF;
}

</style>
